import { c as _c } from "react/compiler-runtime";
import debounce from 'lodash/debounce';
import { useEffect, useState } from 'react';

/** Hook to get the window size */
export const useResize = () => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      width: 0,
      height: 0
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [size, setSize] = useState(t0);
  let t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      const handleResize = debounce(() => {
        setSize({
          width: window.innerWidth,
          height: window.innerHeight
        });
      }, 500);
      window.addEventListener("resize", handleResize);
      return () => {
        window.removeEventListener("resize", handleResize);
      };
    };
    t2 = [];
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  return size;
};